<template>
  <div id="app">
    <router-view/>
  </div>
</template>


<script>
export default {
  data () {
    return {
      defaultTitle: "RedGirasol",
    }
  },
  watch: {
    '$route' (to){
      document.title = to.meta.title ? `${this.defaultTitle} - ${to.meta.title}` : this.defaultTitle;
    }
  }
}
</script>

<style>
a {
  cursor: pointer;
}
</style>